import { httpClient } from '@/services/http/httpClient'

import type { Tenant } from '../types'

export type GetTenantParams = {
  slug: string
}

export async function getBySlug({ slug }: GetTenantParams): Promise<Tenant> {
  const { data } = await httpClient.get(`/tennants/by-slug/${slug}`)

  return {
    id: data.tennant.id,
    name: data.tennant.name,
    slug: data.tennant.slug,
    status: data.tennant.status,
  }
}
